// src/lib/dateRanges.js
// All ranges are inclusive of start 00:00:00 and inclusive of end 23:59:59 local (America/New_York).

const tzOffsetMs = () => {
  // Use local offset at runtime; you can swap to luxon if you prefer strict TZ handling.
  return new Date().getTimezoneOffset() * 60 * 1000 * -1;
};

const startOfMonth = (d = new Date()) => new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
const endOfMonth   = (d = new Date()) => new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);

// Current “active” month: today’s calendar month
export const currentMonthRange = () => {
  const now = new Date();
  return {
    label: "Current Month",
    start: startOfMonth(now),
    end: endOfMonth(now),
  };
};

// Last 3 full, completed months: exclude the current month entirely
export const last3FullMonthsRange = () => {
  const now = new Date();
  const currentStart = startOfMonth(now);
  const m1End = new Date(currentStart - 1); // last day of previous month
  const m1Start = startOfMonth(m1End);
  const m2End = new Date(m1Start - 1);
  const m2Start = startOfMonth(m2End);
  const m3End = new Date(m2Start - 1);
  const m3Start = startOfMonth(m3End);

  return {
    label: "Last 3 Full Months",
    months: [
      { start: m3Start, end: m3End },
      { start: m2Start, end: m2End },
      { start: m1Start, end: m1End },
    ],
  };
};

// Convenience: a single combined range that spans all 3 months (for tiles that need rolled-up totals)
export const last3FullMonthsCombined = () => {
  const r = last3FullMonthsRange();
  return {
    label: r.label,
    start: r.months[0].start,
    end: r.months[2].end,
  };
};